import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {AppState, clearAuthStorageData} from "../../reducers/reducer";
import {login, loginError, loginSuccess, logout, logoutSuccess, storeTokens} from "../actions/auth.actions";
import {exhaustMap, tap} from "rxjs/operators";
import {AuthService} from "../services/auth.service";
import {catchError, map, of} from "rxjs";
import {LoginResponseDto} from "../models/auth.model";
import {StradiaRoutes} from "../../shared/enum/routes.enum";


@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private store: Store<AppState>,
    private authService: AuthService,
  ) {}

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(login),
      exhaustMap(action =>
        this.authService.login(action.username, action.password).pipe(
          map((response: LoginResponseDto) => loginSuccess({ token: response.token, user: response.user, refreshToken: response.refreshToken })),
          catchError(error => {
            return of(loginError({ error: error?.error?.message ? error?.error?.message : 'Errore del server' }));
          })
        )
      )
    )
  );

  loginSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loginSuccess),
        tap((response: LoginResponseDto) => {
          localStorage.setItem(`isRefreshing`, `false`);
          this.store.dispatch(storeTokens(response));
          return this.router.navigate([StradiaRoutes.MAP]);
        })
      ),
    { dispatch: false }
  );

  storeTokens$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(storeTokens),
        tap(action => {
          localStorage.setItem('auth', JSON.stringify(action.token));
          localStorage.setItem('refresh', JSON.stringify(action.refreshToken));
          localStorage.setItem('user', JSON.stringify(action.user));
        })
      ),
    { dispatch: false }
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(logout),
      exhaustMap(() => this.authService.logout().pipe(map(() => logoutSuccess())))
    )
  );

  logoutSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(logoutSuccess),
        tap(async () => {
          await this.router.navigate(['login']);
          clearAuthStorageData();
          location.reload();
        })
      ),
    { dispatch: false }
  );
}
